*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  /**
   * @prop --ch-action-list-item__image-size:
   * Specifies the box size that contains the images for the additional images.
   * @default 0.875em
   */
  --ch-action-list-item__image-size: 0.875em;
  /**
   * @prop --ch-action-list-item__background-image-size:
   * Specifies the image size of the additional images.
   * @default 100%
   */
  --ch-action-list-item__background-image-size: 100%;
  /**
   * @prop --ch-action-list-group__expandable-button-size:
   * Specifies the box size that contains the expandable button image.
   * @default 0.875em
   */
  --ch-action-list-group__expandable-button-size: 0.875em;
  /**
   * @prop --ch-action-list-group__expandable-button-image-size:
   * Specifies the image size of the expandable button.
   * @default 100%
   */
  --ch-action-list-group__expandable-button-image-size: 100%;
  --ch-action-list-item__additional-item-fixed-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9.8 7.36V5.6H9V4H17V5.6H16.2V12L17.8 13.6V15.2H17.64L14.6 12.16V5.6H11.4V8.96L9.8 7.36ZM19.4 18.96L18.36 20L13.64 15.28V20H12.36V15.2H8.2V13.6L9.8 12V11.44L5 6.64L6.04 5.6L19.4 18.96ZM10.44 13.6H11.88L11.16 12.88L10.44 13.6Z"/></svg>');
  --ch-action-list-item__additional-item-not-fixed-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15 12V5.6H15.8V4H7.8V5.6H8.6V12L7 13.6V15.2H11.16V20H12.44V15.2H16.6V13.6L15 12ZM9.24 13.6L10.2 12.64V5.6H13.4V12.64L14.36 13.6H9.24Z"/></svg>');
  --ch-action-list-item__additional-item-remove-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.18998 8.81H16.79V18C16.7927 18.3969 16.6369 18.7785 16.3571 19.0601C16.0774 19.3417 15.6969 19.5 15.3 19.5H8.68001C8.2831 19.5 7.90259 19.3417 7.62287 19.0601C7.34315 18.7785 7.18735 18.3969 7.18998 18V8.81ZM15.31 5.89V5.73C15.3045 5.08221 14.7778 4.56 14.13 4.56H9.85001C9.2022 4.56 8.6755 5.08221 8.67001 5.73V5.89H5.51001V7.39H18.51V5.89H15.31Z"/></svg>');
  --ch-action-list-item__additional-item-modify-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5.58 14.38L9.58 18.38L4.77 19.23L5.58 14.38ZM13.31 6.66L17.3 10.65L10.64 17.32L6.64 13.32L13.31 6.66ZM15.95 4.64302C16.3442 4.64302 16.7222 4.80031 17 5.08L18.84 6.94C19.3861 7.51811 19.3861 8.42189 18.84 9L18.39 9.6L14.39 5.6L14.9 5.08C15.1778 4.80031 15.5558 4.64302 15.95 4.64302Z"/></svg>');
  --ch-action-list-item__additional-item-confirm-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10 17.42L5 12.42L6.41 11L10 14.59L17.59 7L19 8.42L10 17.42Z"/></svg>');
  --ch-action-list-item__additional-item-cancel-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"/></svg>');
  --ch-action-list-item__action-color: currentColor;
  display: grid;
  grid-auto-rows: max-content;
  block-size: 100%;
  overflow: auto;
  contain: size;
}

.separator {
  display: grid;
  block-size: 1px;
  background-color: currentColor;
}